module.exports = __webpack_public_path__ + "media/svg/arrow-select-3137eea8.svg";